// components/MemberActions.tsx - Boutons d'actions réutilisables
import React from 'react';
import { Download, FileText, X } from 'lucide-react';

interface MemberActionsProps {
    isDownloadingCard: boolean;
    isDownloadingPDF: boolean;
    downloadError: string | null;
    pdfError: string | null;
    onDownloadCard: () => void;
    onGeneratePDF: () => void;
    onClearDownloadError: () => void;
    onClearPdfError: () => void;
}

const MemberActions: React.FC<MemberActionsProps> = ({
                                                         isDownloadingCard,
                                                         isDownloadingPDF,
                                                         downloadError,
                                                         pdfError,
                                                         onDownloadCard,
                                                         onGeneratePDF,
                                                         onClearDownloadError,
                                                         onClearPdfError
                                                     }) => {
    return (
        <div className="space-y-4">
            {/* Messages d'erreur */}
            {downloadError && (
                <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                    <div className="flex justify-between items-start">
                        <p className="text-red-800 text-sm">{downloadError}</p>
                        <button
                            onClick={onClearDownloadError}
                            className="text-red-600 hover:text-red-800 ml-2"
                        >
                            <X className="w-4 h-4"/>
                        </button>
                    </div>
                </div>
            )}

            {pdfError && (
                <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                    <div className="flex justify-between items-start">
                        <p className="text-red-800 text-sm">{pdfError}</p>
                        <button
                            onClick={onClearPdfError}
                            className="text-red-600 hover:text-red-800 ml-2"
                        >
                            <X className="w-4 h-4"/>
                        </button>
                    </div>
                </div>
            )}

            {/* Boutons d'action */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Télécharger la carte */}
                <button
                    onClick={onDownloadCard}
                    disabled={isDownloadingCard}
                    className="bg-blue-600 hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed text-white px-6 py-3 rounded-lg font-semibold transition-colors flex items-center justify-center space-x-2 shadow-lg"
                >
                    {isDownloadingCard ? (
                        <>
                            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                            <span>Téléchargement...</span>
                        </>
                    ) : (
                        <>
                            <Download className="w-5 h-5"/>
                            <span>Télécharger la carte</span>
                        </>
                    )}
                </button>

                {/* Générer PDF */}
                <button
                    onClick={onGeneratePDF}
                    disabled={isDownloadingPDF}
                    className="bg-green-600 hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed text-white px-6 py-3 rounded-lg font-semibold transition-colors flex items-center justify-center space-x-2 shadow-lg"
                >
                    {isDownloadingPDF ? (
                        <>
                            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                            <span>Génération...</span>
                        </>
                    ) : (
                        <>
                            <FileText className="w-5 h-5"/>
                            <span>Fiche d'adhésion PDF</span>
                        </>
                    )}
                </button>
            </div>
        </div>
    );
};

export default MemberActions;
